import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {NavLink,  withRouter} from 'react-router-dom';

import { parseDate } from '../../../Helpers/HelperFunctions';

class SingleMessage extends Component {

    constructor(props) {
        super(props);
        this._renderSidebar = this._renderSidebar.bind(this);


    }
    _renderSidebar(is_priority) {
        if(is_priority === '1') {
            return <div className="message__sidebar message__sidebar--priority"></div>
        }else{
            return <div className="message__sidebar"></div>
        }
    }
    _renderCircle(isPriority, hasBeenRead) {
        if(isPriority === '1') {
            if(hasBeenRead === '1') {
                return <div className="circle circle--red"></div>
            }else{
                return <div className="circle circle--red circle--filled circle--filled--red"></div>
            }
        }else{
            if(hasBeenRead === '1') {
                return <div className="circle circle--green"></div>
            }else{
                return <div className="circle circle--green circle--filled circle--filled--green"></div>
            }
        }
    }
    _IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

     _mapValues = (item, key) => {
       return (
            <li key={key}>
                {item.clickable ? <span style={{color: '#0a60a7', cursor: 'pointer'}} onClick={(e) => this.props.setSearchTerm(item.value)}><strong>{item.category} - {item.value}</strong></span> : <span>{item.category} - {item.value}</span>}
            </li>
        )
    }

    _mapValuesLimited(item, key) {

       return (
            <div className="limited__value" key={key}>
                {item ? item.category + '-' + item.value : ''}
            </div>
        )
    }
    _getFirstValues(message) {


        if(message.json_message) {
            let jsonMessage = false;
            if(this._IsJsonString(message.json_message)) {
                jsonMessage = JSON.parse(message.json_message);
            }
            let valueArray = [];
            if(jsonMessage.values) {
                for(let i = 0; i <= jsonMessage.values.length; i++) {
                    if(i < 2) {
                        valueArray.push(jsonMessage.values[i]);
                    }
                }
            }

            if(jsonMessage) {
                return(
                    <div>
                        {valueArray.length > 0 ? valueArray.map(this._mapValuesLimited) : null}
                    </div>
                )
            }else{
                return false;
            }

        }
    }

    _getExecutedDate(message){
        let result = false;
        if ( message.metaDataAsList ) {
            message.metaDataAsList.forEach((item, i) => {
                if ( item.Uitvoerdatum ) {
                    result = moment(item.Uitvoerdatum, 'DD-MM-YYYY').format('DD-MM-YYYY');
                }
            });
        }

        return result;
    }

    _createMesssage(message) {


        if(message.json_message) {
            let jsonMessage = false;
            if(this._IsJsonString(message.json_message)) {
                jsonMessage = JSON.parse(message.json_message);
            }

            if(jsonMessage) {
                return(
                    <div>
                        {jsonMessage.content}
                        <ul>
                            {jsonMessage.values ? jsonMessage.values.map(this._mapValues) : message.message}
                        </ul>
                        <br />
                        <a className="file__url" target="_blank" href={'/image/api/'+message.filename}>Bekijk bestand</a>
                    </div>
                )
            }else{
                return false;
            }

        }
    }
    _getCheckboxChecked = (id) => {

        return this.props.selectedMessages.includes(id);

    }
    render() {
    	let message = this.props.message;

        let smaller = this.props.smaller ? 'smaller fullmessage' : 'fullmessage';
        let wrapperClass = this.props.wrapperClass ? this.props.wrapperClass : '';
        return (
            <li id={"message-"+message.message_id} className={"single__message " + this.props.activeClass + ' ' + smaller + ' ' + wrapperClass}>
                {this.props.isFromOverview ?
                    <div className="message__checkbox" style={{display: 'none'}}>
                        <div className="message__checkbox__inner">
                            <input type="checkbox" data-attr={message.message_id} checked={this._getCheckboxChecked(message.message_id)} onClick={() => this.props.setActiveCheckbox(message.message_id)}/>
                        </div>
                    </div>
                : null }
                <div className="message__notifiers">
                    {this._renderSidebar(message.is_priority)}
                    <div className="message__circles">
                        {this._renderCircle(message.is_priority, message.has_been_read)}
                    </div>
                </div>
                <div style={{cursor: 'pointer'}} onClick={(e, messageId) => this.props.showDetails(e, message.message_id, message.id)} className={this.props.messageClass +  ' message-grid__wrapper'}>
                    <div className="message__inner message__inner--left">
                        <div className="subject">
                            {message.subject}
                        </div>

                        <div className="content">
                            {this._getFirstValues(message)}
                        </div>
                    </div>
                    <div className="message__inner message__inner--center">
                        <div className="date">
                            {parseDate(message.date_send)}
                        </div>
                    </div>
                    <div className="message__inner message__inner--center-executed">
                        <div className="date">
                            {this._getExecutedDate(message)}

                        </div>
                    </div>

                    <div className="message__inner message__inner--right">
                        <div className="date">
                            <a href="#open" onClick={(e, messageId) => this.props.showDetails(e, message.message_id, message.id)}>{this.props.smaller ? '' : <span>Toon details</span>}</a>
                        </div>
                    </div>
                </div>

                <div className={"message__content"}>
                    {this._createMesssage(message)}
                </div>
            </li>
        );
    }

}



function mapStateToProps (state) {
    return {
        messages: state.messagesReducer.messages,

    }
}
const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(SingleMessage));



// WEBPACK FOOTER //
// ./src/components/Messages/View/index.js